'use es6';

import NewThreadPrompt from '../../thread-create/components/NewThreadPrompt';
import { connect } from 'react-redux';
import { navigateToStagedThread } from '../../navigation/actions/navigateToStagedThread';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
const mapStateToProps = state => {
  const {
    accentColor,
    useDefaultColor
  } = getColoring(state);
  return {
    accentColor,
    useDefaultColor
  };
};
const mapDispatchToProps = {
  createNewThread: navigateToStagedThread
};
export default connect(mapStateToProps, mapDispatchToProps)(NewThreadPrompt);